import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { NumberService } from '@rd/core/services/number/number.service';

@Pipe({
  name: 'localizeNumber',
  pure: false,
})
export class LocalizeNumberPipe implements PipeTransform {
  constructor(private numberService: NumberService) {}

  public transform(value: number, digitsInfo?: string): string {
    return this.numberService.formatNumber(value, digitsInfo);
  }
}

@NgModule({
  declarations: [LocalizeNumberPipe],
  exports: [LocalizeNumberPipe],
})
export class LocalizeNumberPipeModule {}
